import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import Grid from '@material-ui/core/Grid';

import { CampaignsBase } from './CampaignsBase';
import { Helper } from '../../../common/helpers/Helper';
import { AppHelper } from '../../../helpers/AppHelper';
import { CdpHelper } from '../../../helpers/CdpHelper';
import { LineChartCard } from '../../../common/components/charts/ChartCard';
import { StatCard } from '../../../common/components/StatCard';
import { AppTheme } from '../../../styles/AppTheme';

function getUniquePercent(value, total) {
  let numUniquePercent = Math.round((value / total) * 100)
  numUniquePercent = isNaN(numUniquePercent) ? '0%' : `${numUniquePercent}%`
  return numUniquePercent
}

export class CrmSequences extends CampaignsBase {
  constructor(props, options) {
    super(props, {
      ...options,
      pageTitle: Helper.getString('crm-sequences'),
      pageKey: 'crm-sequences',
      campaignType: 'DRIP',
    });
    const campaignsFetch = this.toFetch.find(f => f.key === 'campaigns')
    if (campaignsFetch && campaignsFetch.queryParams && AppHelper.isSettingEnabled(this.orgId, 'DRIP_CAMPAIGN_CHARTS')) {
      campaignsFetch.queryParams.includeStats = 'YES'
    }
  }

  async onFetchSuccess(results, options) {
    const { fetchNext } = options || {}
    super.onFetchSuccess(results, options)
    if (fetchNext) {
      return
    }
    const { stats } = this.campaigns
    this.setState({
      dripExecuteStats: stats && stats.drip && stats.drip.executeStats,
    })
    const showDripActivityCharts = AppHelper.isSettingEnabled(this.orgId, 'DRIP_CAMPAIGN_CHARTS')
    if (!showDripActivityCharts) {
      this.setState({
        showDripActivityCharts: false,
        engagementChartData: null,
      })
      return
    }
    const dripActivityCharts = await CdpHelper.fetchDripActivityCharts({ orgId: this.orgId })
    this.setState({
      showDripActivityCharts: true,
      engagementChartData: dripActivityCharts.engagementChartData,
    })
  }

  renderAboveTable() {
    const { showDripActivityCharts, dripExecuteStats } = this.state
    if (!showDripActivityCharts && !dripExecuteStats) {
      return null
    }
    const engagementChartData = this.state.engagementChartData || CdpHelper.getDripEngagementChartData([])
    return (
      <div className={css(Styles.aboveTableContainer)}>
        {showDripActivityCharts && <div className={css(Styles.activityChartsContainer)}>
          <LineChartCard item={{
            title: 'Activity',
            data: engagementChartData,
            xLabelsDifference: 4,
            showLegend: (engagementChartData.datasets || []).length > 1,
          }} />
        </div>}
        {dripExecuteStats && this.renderStats(dripExecuteStats)}
      </div>
    )
  }

  renderStats(executeStats) {
    const numUniqueSent = executeStats.attemptedCount || 0
    const numUniqueOpened = executeStats.openCount || 0
    const numUniqueClicked = executeStats.clickCount || 0
    const numUniqueReplied = executeStats.replyCount || 0
    const numUniqueBounced = executeStats.bounceCount || 0

    return <>
      <Grid container className={css(Styles.numericStatContainer)}>
        <StatCard
          xs={12}
          sm={3}
          key={'enrolments'}
          text={executeStats.subscribedCount || 0}
          subText={'Enrolments'}
          cardIndex={1}
          padding='small'
        />
        <StatCard
          xs={12}
          sm={3}
          key={'uniqueSent'}
          text={numUniqueSent}
          subText={'Unique Sent'}
          cardIndex={1}
          padding='small'
        />
        <StatCard
          xs={12}
          sm={3}
          key={'allStepsDone'}
          text={executeStats.allStepsDoneCount || 0}
          subText={'All Steps Done'}
          cardIndex={3}
          padding='small'
        />
        <StatCard
          xs={12}
          sm={3}
          key={'numUnenrols'}
          text={executeStats.unenrolCount || 0}
          subText={'Unenrols'}
          cardIndex={4}
          padding='small'
        />
      </Grid>
      <Grid container className={css(Styles.numericStatContainer)}>
        <StatCard
          xs={12}
          sm={3}
          key={'uniqueOpened'}
          text={numUniqueOpened}
          subText={'Unique Opened'}
          cardIndex={2}
          padding='small'
        />
        <StatCard
          xs={12}
          sm={3}
          key={'uniqueClicked'}
          text={numUniqueClicked}
          subText={'Unique Clicked'}
          cardIndex={3}
          padding='small'
        />
        <StatCard
          xs={12}
          sm={3}
          key={'uniqueReplied'}
          text={numUniqueReplied}
          subText={'Unique Replied'}
          cardIndex={4}
          padding='small'
        />
        <StatCard
          xs={12}
          sm={3}
          key={'uniqueBounced'}
          text={numUniqueBounced}
          subText={'Unique Bounced'}
          cardIndex={5}
          padding='small'
        />
      </Grid>
      <Grid container className={css(Styles.numericStatContainer)}>
        <StatCard
          xs={12}
          sm={3}
          key={'uniqueOpenedPercent'}
          text={getUniquePercent(numUniqueOpened, numUniqueSent)}
          subText={'Open Rate'}
          cardIndex={2}
          padding='small'
        />
        <StatCard
          xs={12}
          sm={3}
          key={'uniqueClickedPercent'}
          text={getUniquePercent(numUniqueClicked, numUniqueSent)}
          subText={'Click Rate'}
          cardIndex={3}
          padding='small'
        />
        <StatCard
          xs={12}
          sm={3}
          key={'uniqueRepliedPercent'}
          text={getUniquePercent(numUniqueReplied, numUniqueSent)}
          subText={'Reply Rate'}
          cardIndex={4}
          padding='small'
        />
        <StatCard
          xs={12}
          sm={3}
          key={'uniqueBouncedPercent'}
          text={getUniquePercent(numUniqueBounced, numUniqueSent)}
          subText={'Bounce Rate'}
          cardIndex={5}
          padding='small'
        />
      </Grid>
    </>
  }

  onCompleteAction(options) {
    if(options.apiInvokeData.responseBody && options.apiInvokeData.responseBody.id) {
      window.open(this.baseRoute() + `/campaigns/sequences/${options.apiInvokeData.responseBody.id}`,'_self')
    } else {
      this.setState({ modalOpen: false, items: [], dialogApiData: options.apiInvokeData })
      this.fetchItems()
    }
  }
}

const Styles = StyleSheet.create({
  aboveTableContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  numericStatContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    '@media (max-width: 767px)': {
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
    justifyContent: 'space-between',
    marginBottom: 16,
    gap: '16px',
  },
  activityChartsContainer: {
    width: '100%',
    maxWidth: AppTheme.viewPort,
    marginBottom: 16,
  },
})
